import React from 'react';
import UTCTime from '../UTCTime/UTCTime';
import './SimpleOfferItem.css';

interface SimpleOfferItemProps {
  offer: any;
  canEdit: boolean;
  canWithdraw: boolean;
  canAccept: boolean;
  onEdit: (offer: any) => void;
  onWithdraw: (offerId: string) => void;
  onAccept: (offerId: string) => void;
}

function SimpleOfferItem({ offer, canEdit, canWithdraw, canAccept, onEdit, onWithdraw, onAccept }: SimpleOfferItemProps) {
  return (
    <div className="simple-offer-item">
      <div className="offer-header">
        <div className="offer-user">
          <strong>{offer.user.nation}</strong>
          <span className="offer-date">
            <UTCTime date={offer.createdAt} />
          </span>
        </div>
        <div className="offer-actions">
          {canAccept && (
            <button onClick={() => onAccept(offer.id)} className="btn btn-sm btn-success">
              Accept Offer
            </button>
          )}
          {canEdit && (
            <button onClick={() => onEdit(offer)} className="btn btn-sm btn-outline">
              Edit
            </button>
          )}
          {canWithdraw && (
            <button onClick={() => onWithdraw(offer.id)} className="btn btn-sm btn-danger">
              Withdraw
            </button>
          )}
        </div>
      </div>
      <div className="offer-content">
        {offer.description}
      </div>
    </div>
  );
}

export default SimpleOfferItem;
